module.exports = __webpack_public_path__ + "static/media/9DESA14.98ac7214.jpg";